export default {"src":"/_next/static/media/business-dark.f6cea1d5.svg","height":36,"width":27};